import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { PlatformUtils_getInstancezyao53u70tqo as PlatformUtils_getInstance } from '../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installPlugin($this, plugin) {
  if ($this.k5k_1.t4(plugin.m3()))
    return Unit_instance;
  var tmp0 = $this.k5k_1;
  var tmp2 = plugin.m3();
  // Inline function 'kotlin.collections.set' call
  var value = (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.r5j_1.o4q(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.u5j_1.l5k_1.v4(plugin.m3()));
    var pluginData = plugin.o5l(config);
    plugin.p5l(pluginData, scope);
    attributes.l4q(plugin.m3(), pluginData);
    return Unit_instance;
  };
  tmp0.b5(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
var HttpClientConfigClass;
function HttpClientConfig() {
  if (HttpClientConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.k5k_1 = LinkedHashMap().fc();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.l5k_1 = LinkedHashMap().fc();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.m5k_1 = LinkedHashMap().fc();
        var tmp_2 = this;
        tmp_2.n5k_1 = HttpClientConfig$engineConfig$lambda;
        this.o5k_1 = true;
        this.p5k_1 = true;
        this.q5k_1 = false;
        this.r5k_1 = PlatformUtils_getInstance().k4s_1;
      }
      q5l(plugin, configure) {
        var previousConfigBlock = this.l5k_1.v4(plugin.m3());
        var tmp0 = this.l5k_1;
        var tmp2 = plugin.m3();
        // Inline function 'kotlin.collections.set' call
        var value = (_this__u8e3s4) => {
          var tmp0_safe_receiver = previousConfigBlock;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
          return Unit_instance;
        };
        tmp0.b5(tmp2, value);
        installPlugin(this, plugin);
      }
      s5k(plugin, configure, $super) {
        var tmp;
        if (configure === VOID) {
          tmp = HttpClientConfig$install$lambda;
        } else {
          tmp = configure;
        }
        configure = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.q5l(plugin, configure);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.q5l.call(this, plugin, configure);
        }
        return tmp_0;
      }
      t5k(key, block) {
        // Inline function 'kotlin.collections.set' call
        this.m5k_1.b5(key, block);
      }
      e5k(client) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.k5k_1.x4().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.apply' call
          element(client);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.m5k_1.x4().p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          // Inline function 'kotlin.apply' call
          element_0(client);
        }
      }
      u5k(other) {
        this.o5k_1 = other.o5k_1;
        this.p5k_1 = other.p5k_1;
        this.q5k_1 = other.q5k_1;
        var tmp0 = this.k5k_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map = other.k5k_1;
        tmp0.d5(map);
        var tmp0_0 = this.l5k_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_0 = other.l5k_1;
        tmp0_0.d5(map_0);
        var tmp0_1 = this.m5k_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_1 = other.m5k_1;
        tmp0_1.d5(map_1);
      }
    }
    initMetadataForClass($, 'HttpClientConfig', HttpClientConfig);
    HttpClientConfigClass = $;
  }
  return HttpClientConfigClass;
}
//region block: exports
export {
  HttpClientConfig as HttpClientConfigo6p492ed655g,
};
//endregion

//# sourceMappingURL=HttpClientConfig.mjs.map
